import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------
// Uses @mui/material GlobalStyles so theme comes from the same ThemeProvider.
// Previously used @mui/styles withStyles, which did not receive @mui theme.
// ----------------------------------------------------------------------

export default function GlobalStyles() {
  return (
    <MuiGlobalStyles
      styles={(theme) => ({
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box'
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitTextSizeAdjust: '100%',
          msTextSizeAdjust: '100%',
          WebkitOverflowScrolling: 'touch',
          touchAction: 'manipulation'
        },
        body: {
          width: '100%',
          height: '100%',
          overflowX: 'hidden',
          fontFamily: theme.typography.fontFamily,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale'
        },
        '#root': {
          width: '100%',
          height: '100%',
          overflowX: 'hidden'
        },
        'input, textarea, select': {
          fontSize: '16px !important',
          '&:focus': {
            fontSize: '16px !important',
            outline: 'none'
          },
          '&:focus-visible': {
            outline: '2px solid #0ea5e9',
            outlineOffset: '2px'
          }
        },
        /* MUI input focus: ensure all TextField/Input focus rings use sky blue (overrides theme primary) */
        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#0ea5e9 !important',
          borderWidth: '2px !important'
        },
        '.Mui-focused .MuiInput-underline::after, .Mui-focused .MuiFilledInput-underline::after': {
          borderBottomColor: '#0ea5e9 !important'
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
            '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' }
          }
        },
        textarea: {
          '&::-webkit-input-placeholder': { color: theme.palette.text.disabled },
          '&::-moz-placeholder': { opacity: 1, color: theme.palette.text.disabled },
          '&:-ms-input-placeholder': { color: theme.palette.text.disabled },
          '&::placeholder': { color: theme.palette.text.disabled }
        },
        a: { color: theme.palette.primary.main },
        img: {
          display: 'block',
          maxWidth: '100%',
          height: 'auto'
        },
        '.MuiAppBar-root': {
          userSelect: 'none',
          WebkitUserSelect: 'none',
          WebkitTouchCallout: 'none'
        },
        '.MuiContainer-root': {
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
          [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
          }
        }
      })}
    />
  );
}
